import { isEmpty } from 'lodash'

const arrayIndexSize = (array = []) => (isEmpty(array) ? 0 : array.length - 1)

export default arrayIndexSize
